// import isEmpty  from 'lodash/isEmpty';

let compName = 'Contacts'

const initialState = {
    list:[],
}

export default (state = initialState, action = {}) => {
    
    
    switch (action.type) {
        case 'INITIALIZE_CONTACTS':  /* called when sendInvites component mounts */
            return {
                list: action.list
            }
        case 'UPDATE_CONTACTS':      /* called when sendInvites adds/deletes participants */
            return {
                list: action.list
            }
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/contacts.js